import React from 'react';
import PropTypes from 'prop-types';
import { IconText } from 'web-ui-components/lib/molecules/icon-text';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';

const ReviewAuthorisationHeader = ({ authorisationTitle, authorisationContent }) => (
	<HighlightTile type="info">
		<div className="u-margin-bottom-2">
			<IconText iconType="AuthorisationLarge" iconColor="warn" iconSize="sm" layout="left">
				<h3 className="u-margin-bottom-0">{authorisationTitle}</h3>
			</IconText>
			<p className="u-margin-bottom-0 u-margin-top-1">{authorisationContent}</p>
		</div>
	</HighlightTile>
);
ReviewAuthorisationHeader.propTypes = {
	authorisationTitle: PropTypes.string.isRequired,
	authorisationContent: PropTypes.string.isRequired,
};

export default ReviewAuthorisationHeader;
